import { useQueryClient } from "@tanstack/react-query";

import { useCreateOrAddDealOpportunitiesFromCsvUpload } from "@vega-api/generated/coinvest-deal-opportunity-upload/coinvest-deal-opportunity-upload";
import { getGetDealShortlistQueryKey } from "@vega-api/generated/coinvest-deal-shortlist/coinvest-deal-shortlist";

import { OPPORTUNITIES_CSV_UPLOAD_INPUT_ID } from "../../constants/prospectsUpload";

import { useDealCsvUpload } from "./useDealCsvUpload";

type UseOpportunitiesCsvUploadParams = {
  dealId: string;
  onUploadSuccess?: () => void;
};

export const useOpportunitiesCsvUpload = ({
  dealId,
  onUploadSuccess,
}: UseOpportunitiesCsvUploadParams) => {
  const queryClient = useQueryClient();
  const uploadMutation = useCreateOrAddDealOpportunitiesFromCsvUpload();

  return useDealCsvUpload({
    dealId,
    uploadMutation,
    inputElementId: OPPORTUNITIES_CSV_UPLOAD_INPUT_ID,
    onUploadSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: getGetDealShortlistQueryKey(dealId),
      });
      onUploadSuccess?.();
    },
  });
};
